module.exports = __webpack_public_path__ + "media/luxury-2026/stanwich-facade-drone-5eefa530.jpg";